import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  showFull?: boolean;
}
interface IMediaProps extends IProps {
  isActive?: boolean;
}

export const Wrapper = styled.div<IProps>`
  border-radius: ${rem(20)} ${rem(20)} 0 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 5;
  ${({ showFull, theme }) =>
    showFull
      ? `
    background :${theme.color.white};
    transition: 0.3s ease-out;
    box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.1);
    `
      : `
    background :rgba(255,255,255,0);
  `}
`;

export const MediaLogo = styled.div<IMediaProps>`
  width: -webkit-fill-available;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
  ${({ showFull }) =>
    showFull
      ? `
          height: ${rem(77)};
        `
      : `
          height:${rem(56)};
        `};

  ${({ theme, isActive }) =>
    isActive
      ? ` 
         background: #FFF5F6;
         border : 2px solid ${theme.color['primary-100']};
         box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.06);
            `
      : `
         background: ${theme.color.white};
         border: 1px solid ${theme.color['gray-300']};
         box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.06);
   `};
`;

export const MediaWrap = styled.div`
  display: flex;
  gap: ${rem(6)};
`;

export const SubTitleWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(20)} 0 ${rem(4)};
`;

export const ButtonWrap = styled.div<IMediaProps>`
  ${({ showFull }) =>
    showFull
      ? `
          padding: ${rem(20)} 0 0;
        `
      : `
          padding: ${rem(8)} 0 0;
        `};
`;

export const Image = styled.img``
